"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _firestorePlus = require("firestore-plus");

var yup = _interopRequireWildcard(require("yup"));

var types = _interopRequireWildcard(require("../types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

class ItemSchema extends _firestorePlus.Schema {
  static postValidate(data) {
    console.log("[ItemSchema#postValidate]", data);
  }

}

exports.default = ItemSchema;
ItemSchema.fieldTypes = {
  createdAt: types.DateTime,
  _geoloc: yup.object({
    lat: yup.number(),
    lng: yup.number()
  }),
  approved: yup.bool(),
  available: yup.bool(),
  avg_rating: yup.number(),
  city: yup.string(),
  deleted: yup.bool(),
  description: yup.string(),
  fake: yup.bool(),
  featured: yup.bool(),
  pictures: yup.array().of(yup.string().url()),
  rating_count: yup.number(),
  missing: yup.bool(),
  name: yup.string(),
  price: types.PriceData,
  ride_count: yup.number(),
  state: yup.string(),
  type: yup.string(),
  // TODO: oneOf Object.values(enums.ITEM_TYPES)
  subtype: yup.string(),
  // TODO: oneOf Object.values(enums.ITEM_SUBTYPES)
  user: types.Firestore.DocumentReference,
  user_img: yup.string().url(),
  user_name: yup.string(),
  user_avg_rating: yup.number(),
  user_rating_count: yup.number()
};
//# sourceMappingURL=Item.js.map